// @flow

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes as times } from '@fortawesome/free-solid-svg-icons';

const back = () => {
  if (window.history.length > 1) { return window.history.back(); }
  return window.location.href = '/';
};

const BackButton = () => <div onClick={back} className="xl:mt-36 w-12 h-12 fixed top-0 right-0 mt-3 mr-3 bg-red-zappelin rounded-full cursor-pointer text-white text-2xl flex items-center justify-center z-50">
  <FontAwesomeIcon icon={times} />
</div>;

export default BackButton;
